import { paths } from 'src/routes/paths';

import packageJson from '../package.json';

// ----------------------------------------------------------------------

export type ConfigValue = {
  appName: string;
  appVersion: string;
  serverUrl: string;
  baseUrl: string;
  assetsDir: string;
  encryptLocalStorageKey: string;
  reqTimeout: number;
  encryptDataKey: string;
  apiEndPoints: any;
  auth: {
    method: 'jwt' | 'amplify' | 'firebase' | 'supabase' | 'auth0';
    skip: boolean;
    redirectPath: string;
  };
  mapboxApiKey: string;
  firebase: {
    appId: string;
    apiKey: string;
    projectId: string;
    authDomain: string;
    storageBucket: string;
    measurementId: string;
    messagingSenderId: string;
  };
  amplify: { userPoolId: string; userPoolWebClientId: string; region: string };
  auth0: { clientId: string; domain: string; callbackUrl: string };
  supabase: { url: string; key: string };
  msalConfig: any;
  muiLicenseKey: string;
};

// ----------------------------------------------------------------------

export const CONFIG: ConfigValue = {
  appName: 'Park City Realty',
  appVersion: packageJson.version,
  serverUrl: process.env.REACT_APP_SERVER_URL ?? '',
  baseUrl: process.env.REACT_APP_BASE_URL ?? '',
  assetsDir: process.env.REACT_APP_ASSETS_DIR ?? '',
  encryptLocalStorageKey:
    process.env.REACT_APP_STORAGE_ENCRYPTION_KEY ?? 'f74808fb03f94ef8f64350a37918c1b0518c',
  reqTimeout: Number(process.env.REACT_APP_REQUEST_TIMEOUT) ?? 90000,
  apiEndPoints: {
    auth: {
      base: '/auth',
      login: '/login',
      signup: '/signup',
      forgetPassword: '/forget_password',
      adminLogin: '/admin/login',
    },
  },
  encryptDataKey: process.env.REACT_APP_ENCRYPT_DATA_KEY ?? '',
  /**
   * Auth
   * @method jwt | amplify | firebase | supabase | auth0
   */
  auth: {
    method: 'jwt',
    skip: false,
    redirectPath: paths.dashboard.root,
  },
  /**
   * Mapbox
   */
  mapboxApiKey: process.env.REACT_APP_MAPBOX_API_KEY ?? '',
  /**
   * Firebase
   */
  firebase: {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY ?? '',
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN ?? '',
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID ?? '',
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET ?? '',
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID ?? '',
    appId: process.env.REACT_APP_FIREBASE_APPID ?? '',
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID ?? '',
  },
  /**
   * Amplify
   */
  amplify: {
    userPoolId: process.env.REACT_APP_AWS_AMPLIFY_USER_POOL_ID ?? '',
    userPoolWebClientId: process.env.REACT_APP_AWS_AMPLIFY_USER_POOL_WEB_CLIENT_ID ?? '',
    region: process.env.REACT_APP_AWS_AMPLIFY_REGION ?? '',
  },
  /**
   * Auth0
   */
  auth0: {
    clientId: process.env.REACT_APP_AUTH0_CLIENT_ID ?? '',
    domain: process.env.REACT_APP_AUTH0_DOMAIN ?? '',
    callbackUrl: process.env.REACT_APP_AUTH0_CALLBACK_URL ?? '',
  },
  /**
   * Supabase
   */
  supabase: {
    url: process.env.REACT_APP_SUPABASE_URL ?? '',
    key: process.env.REACT_APP_SUPABASE_ANON_KEY ?? '',
  },
  msalConfig: {
    auth: [
      {
        clientId: process.env.REACT_APP_MSAL_CLIENT_ID ?? '',
        authority: process.env.REACT_APP_MSAL_AUTHORITY ?? '',
        redirectUri: process.env.REACT_APP_MSAL_REDIRECT_URI ?? 'http://localhost:3000/',
        postLogoutRedirectUri:
          process.env.REACT_APP_MSAL_POST_LOGOUT_REDIRECT_URI ?? 'http://localhost:3000/sign-in',
        domain: 'Microsoft',
      },
    ],
    cache: {
      cacheLocation: 'sessionStorage',
      storeAuthStateInCookie: true,
    },
    system: {},
  },
  muiLicenseKey: process.env.REACT_APP_MUI_LICENSE_KEY ?? '',
};
